import { Button as MButton, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { WHITE } from '../../themes/colors';
import {
  BUTTON_HEIGHT,
  BUTTON_LABEL,
  BUTTON_LABEL_HEIGHT,
} from '../../themes/fonts';

interface Props {
  label: string;
  width: string;
  bgColor: string;
  onClick: () => void;
}

const ConfirmButton: React.FC<Props> = ({
  label,
  width,
  bgColor,
  onClick,
}: Props) => {
  const handleOnClick = useCallback(() => {
    onClick();
  }, [onClick]);

  return (
    <MButton
      onClick={() => handleOnClick()}
      sx={{
        width: width,
        bgcolor: bgColor,
        borderRadius: '10px',
        height: BUTTON_HEIGHT,
      }}
      variant="contained"
    >
      <Typography
        sx={{
          color: WHITE,
          fontSize: BUTTON_LABEL,
          lineHeight: BUTTON_LABEL_HEIGHT,
        }}
      >
        {label}
      </Typography>
    </MButton>
  );
};

export default ConfirmButton;
